import { Button } from '@mui/material'

type OutHourProps = {
  totalOut: number
}
export const OutHour = ({ totalOut }: OutHourProps) => {
  return (
    <Button variant="outlined" size="small" color="error" className="px-1 min-w-fit lowercase">
      -{Number(totalOut.toFixed(2))}h
    </Button>
  )
}
